// import { initializeApp } from 'firebase/app';
// import { getAuth } from "firebase/auth";


// // TODO: Replace the following with your app's Firebase project configuration
// const firebaseConfig = {
//   apiKey: "AIzaSyDMA9yHNUzEhvZpzU1Iy0fRloLltRKjy1M",
//   authDomain: "xeguei-mobile.firebaseapp.com",
//   projectId: "xeguei-mobile",
//   storageBucket: "xeguei-mobile.appspot.com",
//   messagingSenderId: "264256883061",
//   appId: "1:264256883061:web:4d9ac607de790c61abab3c",
//   measurementId: "G-D7Q7S56B57"
// };

// const app = initializeApp(firebaseConfig);
// export const authentication = getAuth(app); 

import { Capacitor } from '@capacitor/core';
import { initializeApp } from 'firebase/app';
import { getAuth, indexedDBLocalPersistence, initializeAuth } from "firebase/auth";
import {
  getFirestore
} from "firebase/firestore";


// TODO: Replace the following with your app's Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyCIpIiOu4ewzfYhDdMIk6AQPXVZUrsMJjI",
  authDomain: "xeguei-empresa.firebaseapp.com",
  projectId: "xeguei-empresa",
  storageBucket: "xeguei-empresa.appspot.com",
  messagingSenderId: "139010064166",
  appId: "1:139010064166:web:6493709a710d66dd6acbe7",
  measurementId: "G-WCRX81E60L"
};

const app = initializeApp(firebaseConfig);
//export const authentication = getAuth(app);

export const authentication = Capacitor.isNativePlatform() ? initializeAuth(app, {
  persistence: indexedDBLocalPersistence
}) : getAuth(app);

export const db = getFirestore(app);